export default __webpack_public_path__ + "static/media/Sage's Legguards of the Purple Sun.b894fe7b.jpg";